import Rails from '@rails/ujs'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import { setCSRFToken, checkResponseStatus } from '@commons/interceptors'
import { HeaderMenu } from '@commons/helpers/headerMenu'
import TusurVueComponents from 'tusur-vue-components'
import VueSvgInlinePlugin from "vue-svg-inline-plugin"
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/ru'
import ScrollToTop from '@commons/components/ScrollToTop.vue'

dayjs.extend(customParseFormat)
dayjs.locale('ru')

Vue.prototype.$dayjs = dayjs
Vue.prototype.$env = process.env.NODE_ENV
Vue.prototype.$gon = gon
// Vue.prototype.$helpers = globalHelpers

Vue.config.productionTip = false

Vue.use(TusurVueComponents)
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueResource)
Vue.use(VueSvgInlinePlugin)
Vue.component(ScrollToTop.name, ScrollToTop)

setCSRFToken()
checkResponseStatus()
Rails.start()

function initVueConfig(routes, baseStore, components, directives, plugins) {
  const store = new Vuex.Store(baseStore)
  const router = new VueRouter({
    routes: routes,
    // Reset Scroll position after change page
    scrollBehavior(to, from, savedPosition) {
      return { x: 0, y: 0 }
    }
  })


  components?.forEach((component) => {
    Vue.component(component.name, component.component)
  })

  directives?.forEach((directive) => {
    Vue.directive(directive.name, directive.component)
  })

  plugins?.forEach((plugin) => {
    Vue.use(plugin.name, plugin.component)
  })

  new HeaderMenu()

  return new Vue({
    store,
    router,
  })
}

export { initVueConfig }
